const TYPE = "empresa";

const empresaModule = {
  findAll: async (dbConnection) => {
    let empresas = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
      },
    });

    if (result.docs.length) {
      empresas = result.docs;
    }
    return empresas;
  },
  buscarPorIdIntegracao: async (dbConnection, id) => {
    let empresa = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        idIntegracao: { $eq: parseInt(id) },
      },
      limit: 1
    });

    if (result.docs.length) {
      empresa = result.docs[0];
    }
    return empresa;
  },
};

export default empresaModule;
